export enum CarePlanActivityTypesArrangement {
  /**
   * Activity types are listed in columns.
   */
  Columns = 'columns',

  /**
   * Activity types are listed in lines.
   */
  Lines = 'lines',

  /**
   * Activity types are listed in Medication format.
   */
  Medication = 'medication',

  /**
   * Activity types are listed in Consulting format.
   */
  MedicalAppointment = 'medical-appointment',
}
